import React from 'react';

// The Unanimity mark — UI cut. Same geometry as the brand reference
// (logo_unanimity_500x500.png: 7 nodes, center larger, square silhouette,
// 19 edges — every pair except the two horizontal chords), with strokes and
// nodes thickened ~1.6x so the mark stays crisp at sidebar size; the print
// weights (3.78/5.44/6.4) blur into a knot below ~40px. Tints via currentColor.
const BrandMark = ({ size = 28, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 100 100"
    aria-hidden="true"
    focusable="false"
  >
    <g stroke="currentColor" strokeWidth="6.0" fill="none"><line x1="50" y1="9" x2="91" y2="29.85"/><line x1="50" y1="9" x2="91" y2="70.15"/><line x1="50" y1="9" x2="50" y2="91"/><line x1="50" y1="9" x2="9" y2="70.15"/><line x1="50" y1="9" x2="9" y2="29.85"/><line x1="50" y1="9" x2="50" y2="50"/><line x1="91" y1="29.85" x2="91" y2="70.15"/><line x1="91" y1="29.85" x2="50" y2="91"/><line x1="91" y1="29.85" x2="9" y2="70.15"/><line x1="91" y1="29.85" x2="50" y2="50"/><line x1="91" y1="70.15" x2="50" y2="91"/><line x1="91" y1="70.15" x2="9" y2="29.85"/><line x1="91" y1="70.15" x2="50" y2="50"/><line x1="50" y1="91" x2="9" y2="70.15"/><line x1="50" y1="91" x2="9" y2="29.85"/><line x1="50" y1="91" x2="50" y2="50"/><line x1="9" y1="70.15" x2="9" y2="29.85"/><line x1="9" y1="70.15" x2="50" y2="50"/><line x1="9" y1="29.85" x2="50" y2="50"/></g><g fill="currentColor"><circle cx="50" cy="9" r="8.2"/><circle cx="91" cy="29.85" r="8.2"/><circle cx="91" cy="70.15" r="8.2"/><circle cx="50" cy="91" r="8.2"/><circle cx="9" cy="70.15" r="8.2"/><circle cx="9" cy="29.85" r="8.2"/><circle cx="50" cy="50" r="9.6"/></g>
  </svg>
);

export default BrandMark;
